// src/hooks/useFlashNews.js
import { useEffect, useState } from "react";
import axios from "axios";

function firstUrl(s = "") {
  const m = String(s || "").match(/\bhttps?:\/\/\S+/i);
  return m ? m[0] : "";
}

function pickArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

function normalize(item, i) {
  const content = String(item.content || item.generatedMessage || item.text || item.message || item.title || "").trim();
  const insertedAt = item.insertedAt || item.createdDate || item.created_at || item.date || item.timestamp || null;
  const mediaUrl = item.mediaUrl || item.image || item.thumbnail || "";
  const source = item.source || item.publisher || "";
  const url = item.url || item.link || firstUrl(content) || "";
  
  return {
    id: item.id ?? item._id ?? `fn-${i}`,
    insertedAt,
    content,
    mediaUrl,
    source,
    url,
  };
}

function makeHeaders(withAuth) {
  const token = process.env.REACT_APP_API_TOKEN || "M3CPztujyCw3QRrhJF7RyMUkpPHJaSEMfjaK5VHqgJVvn6QP82dbvJJz3yJxb2mZ";
  return withAuth && token ? { Authorization: `Bearer ${token}` } : {};
}

export default function useFlashNews() {
  const [news, setNews] = useState(undefined); // wichtig: undefined bis geladen
  const [error, setError] = useState(null);
  const [debug, setDebug] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function tryFetch(url, withAuth) {
      const res = await axios.get(url, { headers: makeHeaders(withAuth) });
      const arr = pickArray(res.data).map((it, i) => normalize(it, i));
      return Array.isArray(arr) ? arr : [];
    }

    async function load() {
      const endpoints = [
        process.env.REACT_APP_FLASH_NEWS_ENDPOINTS || "https://koalio.io/insightx/news/v1",
      ];
      
      const attempts = [];
      let items = [];

      for (const url of endpoints) {
        for (const withAuth of [true, false]) {
          try {
            const arr = await tryFetch(url, withAuth);
            attempts.push({ url, withAuth, ok: true, count: arr.length });
            if (arr.length) {
              items = arr;
              break;
            }
          } catch (e) {
            attempts.push({
              url,
              withAuth,
              ok: false,
              status: e?.response?.status,
              msg: e?.response?.data || e?.message,
            });
          }
        }
        if (items.length) break;
      }

      if (cancelled) return;

      if (items.length) {
        items.sort((a, b) => Date.parse(b.insertedAt || 0) - Date.parse(a.insertedAt || 0));
        setNews(items);
        setError(null);
        setDebug(attempts);
      } else {
        setNews([]); // geladen, aber leer
        setError("Failed to load flash news.");
        setDebug(attempts);
        console.table(attempts);
      }
    }

    load();
    
    // Refresh alle 10 Minuten
    const interval = setInterval(load, 1000 * 60 * 10);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return { news, error, debug };
}